/** @format */

import React, { useEffect, useState } from "react";
import { useId } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { assetsPath } from "../utils/assetsPath";

const LabelInput = ({
  id,
  label,
  type,
  placeholder,
  register,
  errors,
  watch,
  disabled,
  options,
  control,
  trigger,
  className,
  emailclass,
  tooltipText,
  value = "",
  classTick,
  autoComplete,
  classNamelic,
  isLoading,
  classLickField,
  isSearchable,
  maxLength,
  validateIcon = true,
  // inputMode,
  onChange = () => {},
  onInput = () => {},
  liveValidate = true,
  ...props
}) => {
  const [isInputClicked, setIsInputClicked] = useState(true);
  const { assetsPath: _, ...restProps } = props;

  useEffect(() => {
    if (watch && liveValidate) {
      const trig = async () => await trigger(id);
      trig();
    }
  }, [watch]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#e8e8e8" : "white",
      "&:hover": {
        backgroundColor: "#EBEBEB",
      },
      color: state.isSelected ? "#676363" : "black",
      backgroundColor: state.isSelected ? "lightgray" : "white",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    menuList: (provided) => ({
      ...provided,
      overflowY: "scroll",
      maxHeight: "130px",
      height: "100%",
    }),
  };

  const generateId = () => {
    if (typeof window !== "undefined") {
      return `react-select-${Math.random()
        .toString(36)
        .substr(2, 9)}`;
    }
    return null;
  };

  if (id == "phone") {
  }
  useEffect(() => {
    generateId();
  }, []);

  return (
    <div className={`licField ${className} ${classLickField}`}>
      {label && (
        <>
          <label className="labelName" htmlFor={id}>
            {label}
          </label>
        </>
      )}
      <div className={`licField margin-bottom-15`}>
        {type === "select" ? (
          <div className={`select`}>
            <Controller
              name={id}
              control={control}
              rules={{ required: "Required" }}
              render={({ field }) => (
                <>
                  <Select
                    isSearchable={isSearchable ?? false}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      onChange(selectedOption);
                    }}
                    onMenuOpen={props.onMenuOpen}
                    {...props}
                    styles={customStyles}
                    classNames={{
                      singleValue: (state) => "truncate",
                    }}
                    placeholder={isLoading ? "Loading..." : placeholder}
                    value={
                      options.find(
                        (option) => option.value === field.value?.value
                      ) || ""
                    }
                    options={options}
                    isDisabled={disabled || isLoading}
                    id={id}
                    defaultValue=""
                    instanceId={useId()}
                  />
                  {tooltipText && (
                    <span className="tooltip">{tooltipText}</span>
                  )}
                </>
              )}
            />
          </div>
        ) : type === "date" ? (
          <Controller
            name={id}
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <DatePicker
                onClick={() => setIsInputClicked(!isInputClicked)}
                data-clicked={isInputClicked ? "true" : "false"}
                placeholderText="MM/DD/YYYY"
                onChange={(date) => field.onChange(date)}
                selected={field.value}
                dateFormat="MM/dd/yyyy"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className={`inputFields nameinput ${errors ? "error" : ""}`}
              />
            )}
          />
        ) : (
          <div
            data-clicked={isInputClicked ? "true" : "false"}
            className={`newInputField ${classNamelic}  `}
          >
            <input
              {...props}
              autoComplete={autoComplete ?? "off"}
              disabled={disabled}
              onChange={onChange}
              // inputMode={inputMode}
              onBlurCapture={() => setIsInputClicked(true)}
              onBlur={() => setIsInputClicked(true)}
              onFocus={() => setIsInputClicked(false)}
              data-clicked={isInputClicked ? "true" : "false"}
              placeholder={placeholder}
              type={type}
              id={id}
              className={`  ${errors ? "error" : ""} carotstyle`}
              {...register}
              maxLength={maxLength}
              onInput={onInput}
            />
            {tooltipText && (
              <span className={`tooltip ${emailclass}`}>{tooltipText}</span>
            )}
          </div>
        )}

        {!errors && watch && validateIcon && !isLoading && (
          <img
            src={`${assetsPath.tick}`}
            alt="Tick Icon"
            className={`  ${classTick}   tickIcon  ${type == "select" &&
              "right-25"}`}
          />
        )}
        {errors && <span className="errorField">Required</span>}
      </div>
    </div>
  );
};

export default LabelInput;
